import React from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from 'redux-stores/features/authSlice';

import S from '../HomePage.styles';

const UserInfoHeader: React.FC = () => {
  const user = useSelector(selectUser);

  return (
    <S.SubTitle data-testid="TextUsernameWarehouse">
      {user.userName.toLocaleUpperCase()}
      {' | '}
      {user.warehouse?.toLocaleUpperCase()}
    </S.SubTitle>
  );
};

export default UserInfoHeader;
